import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store'

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import Global from '@/components' // 通用组件
import '@/assets/css/global.css'
import Share from 'vue-social-share'//分享插件
import 'vue-social-share/dist/client.css'

import MetaInfo from 'vue-meta-info' // 引入vue-meta-info
Vue.use(MetaInfo) // 注册vue-meta-info

import { setCookie, getCookie, delCookie } from '../src/utils/cookie.js'
Vue.prototype.$cookieStore = { setCookie, getCookie, delCookie }

//页面
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  window.scrollTo(0, 0)
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next()
})
//注册全局通用属性,方法
import ispc from '@/const/ispc'
Vue.use(ispc)

Vue.use(Share)
Vue.use(ViewUI);
Vue.use(Global)
//Vue.prototype.bus = new Vue()
Vue.config.productionTip = false

new Vue({
  // 挂载vuex到Vue实例内部
  store,
  router,
  data: {
    Bus: new Vue()
  },
  // mounted() {
  //   document.dispatchEvent(new Event('render-event'))
  // },
  render: h => h(App),
  // mounted () {
  //   document.dispatchEvent(new Event('render-event'))
  // }
}).$mount('#app')
